import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider, { useAuth } from '../security/security/AuthContext';
import { checkUserRole } from '../security/api/ApiClient';
import Home from '../userDashboard/Home';
import Team from '../userDashboard/Team';
import Order from '../userDashboard/Order';
import SuccessStories from '../userDashboard/SuccessStories';
import Loading from '../userDashboard/auth/loaders/Loading';

import Admin from '../admin/Admin';
import AdminLogin from '../admin/AdminLogin';
import CompanyShares from '../userDashboard/CompanyShares';
import Auth from '../userDashboard/auth/Auth';
import UserFeeds from '../userDashboard/UserFeeds';

function AdminAuthenticatedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [checkingRole, setCheckingRole] = React.useState(true);

  
  React.useEffect(() => {
    const verifyAdminRole = async () => {
      if (isAuthenticated) {
        try {
          const role = await checkUserRole();
          setIsAdmin(role === 'ADMIN');
        } catch (error) {
          console.error('Error verifying admin role:', error);
          setIsAdmin(false);
        }
      }
      setCheckingRole(false);
    };

    verifyAdminRole();
  }, [isAuthenticated]);

  if (isLoading || checkingRole) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/adminaccountlogin/main" />;
  }

  if (!isAdmin) {
    return <Navigate to="/user-dashboard" replace />;
  }

  return children;
}

function AuthenticatedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return <Loading />;
  }
  
  if (isAuthenticated) {
    return children;
  } else {
    return <Navigate to="/" />;
  }
}

export default function AppRoutes() {
  return (
    <div>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Auth />} />
            <Route path="/signup" element={<Auth />} />
            <Route path='/adminaccountlogin/main' element={ <AdminLogin /> } />
            <Route path="/user-dashboard" element={<AuthenticatedRoute><Home /></AuthenticatedRoute>} />
            <Route path="/shares" element={<AuthenticatedRoute><CompanyShares /></AuthenticatedRoute>} />
            <Route path="/team" element={<AuthenticatedRoute><Team /></AuthenticatedRoute>} />
            <Route path="/history" element={<AuthenticatedRoute><Order /></AuthenticatedRoute>} />
            <Route path="/earnings" element={<AuthenticatedRoute><SuccessStories /></AuthenticatedRoute>} />
            <Route path="/feeds" element={<AuthenticatedRoute><UserFeeds /></AuthenticatedRoute>} />

            {/* Admin route with special protection */}
            <Route 
              path="/main/admindashboard/main" 
              element={
                <AdminAuthenticatedRoute>
                  <Admin />
                </AdminAuthenticatedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
